import { connect } from 'react-redux';
import { SidebarComponent } from './Sidebar.component';
import { getCategoriesById, getRoot } from 'shared/store/selectors/knowledge.selector';

const mapStateToProps = ({ lang, organization, knowledge, router }) => {
  let id = router.location?.pathname?.split('/')[2];
  let rootItems = getCategoriesById(knowledge, id || getRoot(knowledge)?.id);

  return {
    lang: lang.SIDEBAR,
    organization,
    rootItems,
    knowledgeLastUpdate: knowledge.lastUpdated,
  };
};

export const Sidebar = connect(mapStateToProps)(SidebarComponent);
